import React from 'react'
import PageHeader from '../components/PageHeader'
import Preloader from '../components/Preloader'
import { CiClock2, CiMail, CiMapPin } from 'react-icons/ci';
import { PiPhoneCallThin, PiCaretDownBold } from 'react-icons/pi';
import { FaLinkedin, FaXTwitter } from "react-icons/fa6";
import Footer from '../components/Footer';
import {
    FaInstagram,
    // FaTiktok 
} from 'react-icons/fa';
import { IoShareSocialOutline } from 'react-icons/io5';
import ScrollReveal from '../components/ScrollReveal';
import { Helmet } from 'react-helmet';

const ContactUs = () => {
    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <Helmet>
                <title>Contact Us | VRIFY Africa</title>
                <meta name="description" content="Get in touch with VRIFY Africa. We are here to answer your questions about our virtual tour services." />
            </Helmet>
            <PageHeader />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/Western-Cape-header.jpg')" }}>
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                        <div className="text-center text-white">
                            <h1 className="text-5xl md:text-6xl font-cormorant-upright font-bold capitalize">Contact us</h1>
                            <p className="text-white max-w-2xl mx-auto text-sm">
                                We'd love to hear from you! If you have any questions, inquiries, or just want to share your travel dreams, feel free to reach out.
                            </p>
                        </div>
                    </div>
                </section>
                <div className="container mx-auto py-20 px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 justify-center max-w-4xl mx-auto">
                        {/* Contact Form */}
                        <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={200}>
                            <div>
                                <h2 className="text-2xl font-semibold text-gray-700 font-cormorant-upright mb-1">Send us a Message</h2>
                                <p className='text-xs font-semibold text-gray-700 mb-4 italic'>By submitting this form, you agree to and that you have read our <a href="/policy-terms" target='_blank' rel='noreferrer' className="hover:text-green-600 hover:underline">privacy policy and terms of service.</a></p>
                                <form action='https://formsubmit.co/business@vrifyafrica.com' method="post" className="space-y-4">
                                    <div className='flex flex-row justify-even items-center gap-5 w-full'>
                                        <div>
                                            <label htmlFor="fullname" className="block text-gray-700 text-sm font-bold mb-2">Full Name<span className='text-sm text-red-600'>*</span></label>
                                            <input type="text" id="fullname" name='fullname' className="shadow text-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="John Doe" required />
                                        </div>
                                        <div>
                                            <label htmlFor="company" className="block text-gray-700 text-sm font-bold mb-2">Company</label>
                                            <input type="text" id="company" name='company' className="shadow text-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Your Company" />
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email<span className='text-sm text-red-600'>*</span></label>
                                        <input type="email" id="email" name='email' className="shadow text-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Your Email" required />
                                    </div>
                                    <div>
                                        <label htmlFor="enquiry" className="block text-gray-700 text-sm font-bold mb-2">Type of Enquiry<span className='text-sm text-red-600'>*</span></label>
                                        <div className="relative">
                                            <select id="enquiry" name='enquiry' className="shadow text-sm font-semibold appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white pr-8" required>
                                                <option className='font-semibold text-sm'>General Inquiry</option>
                                                <option className='font-semibold text-sm'>Booking</option>
                                                <option className='font-semibold text-sm'>Partnership</option>
                                                <option className='font-semibold text-sm'>Support</option>
                                                <option className='font-semibold text-sm'>Other</option>
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <PiCaretDownBold />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <label htmlFor="message" className="block text-gray-700 text-sm font-bold mb-2">Message<span className='text-sm text-red-600'>*</span></label>
                                        <textarea id="message" name='message' rows="5" className="shadow text-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Your Message" required />
                                    </div>
                                    <button type="submit" className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm">
                                        Send Message
                                    </button>
                                </form>
                            </div>
                        </ScrollReveal>
                        {/* Contact Information */}
                        <div className="lg:pl-8">
                            <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={400}>
                                <h2 className="text-2xl font-semibold text-gray-700 font-cormorant-upright mb-4">Contact Information</h2>
                            </ScrollReveal>
                            <div className="space-y-6">
                                <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={600}>
                                    <div className="flex items-start gap-4">
                                        <CiMail className="text-xl text-gray-500" />
                                        <div>
                                            <p className="font-semibold text-gray-500 capitalize cursor-pointer">Emails</p>
                                            <a href="mailto:business@vrifyghana.com" className="text-sm font-semibold hover:text-green-600">business@vrifyghana.com</a><br/>
                                            <a href="mailto:info@vrifyghana.com" className="text-sm font-semibold hover:text-green-600">info@vrifyghana.com</a><br />
                                        </div>
                                    </div>
                                </ScrollReveal>
                                <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={600}>
                                    <div className="flex items-start gap-4">
                                        <PiPhoneCallThin className="text-xl text-gray-500" />
                                        <div>
                                            <p className="font-semibold capitalize text-gray-500 cursor-pointer">Phone numbers</p>
                                            <a href="tel:+233555123456" className="text-sm font-semibold hover:text-green-600 cursor-pointer">+233553139500</a><br />
                                            <a href="tel:+233200987654" className="text-sm font-semibold hover:text-green-600 cursor-pointer">+233544847395</a>
                                        </div>
                                    </div>
                                </ScrollReveal>
                                <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={600}>
                                    <div className="flex items-start gap-4">
                                        <CiMapPin className="text-xl text-gray-500" />
                                        <div>
                                            <p className="font-semibold text-gray-500 capitalize">physical address</p>
                                            <p className="text-sm font-semibold hover:text-green-600 cursor-pointer">East Legon, Accra, Ghana</p>
                                        </div>
                                    </div>
                                </ScrollReveal>
                                <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={600}>
                                    <div className="flex items-start gap-4">
                                        <CiClock2 className="text-xl text-gray-500" />
                                        <div>
                                            <p className="font-semibold capitalize text-gray-500 cursor-pointer">Opening Hours</p>
                                            <p className="text-sm font-semibold hover:text-green-600 cursor-pointer">Monday - Friday: 08:00 - 16:00</p>
                                            <p className="text-sm font-semibold hover:text-green-600 cursor-pointer">Saturday - Sunday: Closed</p>
                                        </div>
                                    </div>
                                </ScrollReveal>
                                <ScrollReveal animationClass="animate-slide-left" threshold={0.1} delay={600}>
                                    <div className="flex items-start gap-4">
                                        <IoShareSocialOutline className="text-xl text-gray-500" />
                                        <div>
                                            <p className="font-semibold capitalize text-gray-500 cursor-pointer">Social Handles</p>
                                            <div className='flex flex-row items-center gap-3 pt-2'>
                                                <FaLinkedin className="text-base text-gray-500 hover:text-green-600 cursor-pointer" />
                                                <FaInstagram className="text-base text-gray-500 hover:text-green-600 cursor-pointer" />
                                                <FaXTwitter className="text-base text-gray-500 hover:text-green-600 cursor-pointer" />
                                                {/* <FaTiktok className="text-base text-gray-500 hover:text-green-600 cursor-pointer" /> */}
                                            </div>
                                        </div>
                                    </div>
                                </ScrollReveal>
                            </div>
                        </div>
                    </div>

                    {/* Google Maps Section */}
                    <section className="mt-16">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={600}>
                            <h2 className="text-2xl font-semibold text-gray-700 font-cormorant-upright mb-4 text-center">Get Direction</h2>
                            <hr className="w-8 border-2 border-black rounded-md mx-auto mb-8" />
                        </ScrollReveal>
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={600}>
                            <div className="overflow-hidden rounded-lg shadow-md max-w-5xl mx-auto">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5459.333600309983!2d-0.1591703882161541!3d5.651575594306118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9dcf4610ecc9%3A0x92f63519e52d0459!2sTGTS%20Africa!5e1!3m2!1sen!2sgh!4v1772191284358!5m2!1sen!2sgh"
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    title="Vrify Ghana Location"
                                ></iframe>
                            </div>
                        </ScrollReveal>
                    </section>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default ContactUs
